import React from 'react';
import { useClass } from '@breezerr';


type UppercaseProps = {
    component: React.ElementType<any>;
} & React.HTMLAttributes<any>;

export const Uppercase = ({ component, children, className, ...props }: UppercaseProps) => {

    const defaultClasses = useClass('d-block uppercase text-size-1.3rem! ls-0.05rem! text-500! lh-1.8rem!').split(' ');
    const propsClasses = className ? className?.split(' ') : [];
    // Merge classNames and make them unique
    const mergedClasses = [...propsClasses, ...defaultClasses].filter((value, index, self) => self.indexOf(value) === index)

    return React.createElement(component, {
        className: mergedClasses.join(' '),
        ...props
    }, children);
};


Uppercase.defaultProps = {
    component: 'span'
};